module.exports = __webpack_public_path__ + "static/media/login.fdde9e75.png";